import NotifierApi from "api/notifierApi";
import * as types from "../actionTypes";
import { sendHttpRequest } from "./httpActions";
import waitForEvent from "utils/events/waitForEvent";
import { showError } from "actions/actionCreators/snackbarActions";

export function loadNotifications(page, pageSize) {
  return async dispatch => {
    try {
      const notifications = await dispatch(sendHttpRequest(NotifierApi.getMyNotifications(page, pageSize)));

      dispatch({ type: types.LOAD_NOTIFICATIONS_SUCCESS, payload: notifications || [] });
      return notifications;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function addNotification(notificationType, notificationBody) {
  return { type: types.ADD_NOTIFICATION, payload: { notificationType, notificationBody } };
}

export function readNotification(notification) {
  return async (dispatch, getState) => {
    try {
      const userId = getState().oidc.user.profile.sub;
      const event = {
        type: types.NOTIFICATION_MARKED_AS_READ,
        event: { ok: true, eventBody: { notificationId: notification.notificationId } }
      };
      dispatch(event);

      if (notification.isPersistent && notification.isRead === false) {
        const { correlationId } = await dispatch(
          sendHttpRequest(NotifierApi.markNotificationAsRead(notification.notificationId, userId))
        );
        return await waitForEvent(correlationId);
      }

      return event;
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function dismissNotification(notification) {
  return async (dispatch, getState) => {
    try {
      const userId = getState().oidc.user.profile.sub;
      const event = {
        type: types.NOTIFICATION_DISMISSED,
        event: { ok: true, eventBody: { notificationId: notification.notificationId } }
      };
      dispatch(event);

      if (notification.isPersistent) {
        const { correlationId } = await dispatch(
          sendHttpRequest(NotifierApi.dismissNotification(notification.notificationId, userId))
        );
        return await waitForEvent(correlationId);
      }
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function markAllAsRead() {
  return async (dispatch, getState) => {
    try {
      const userId = getState().oidc.user.profile.sub;
      const event = {
        type: types.ALL_NOTIFICATIONS_MARKED_AS_READ,
        event: { ok: true, eventBody: { userId } }
      };
      dispatch(event);

      const { correlationId } = await dispatch(sendHttpRequest(NotifierApi.markAllAsRead(userId)));
      return await waitForEvent(correlationId);
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function dismissAllNotifications() {
  return async (dispatch, getState) => {
    try {
      const userId = getState().oidc.user.profile.sub;
      dispatch({ type: types.ALL_FRONTEND_NOTIFICATIONS_DISMISSED });

      const { correlationId } = await dispatch(sendHttpRequest(NotifierApi.dismissAllNotifications(userId)));
      return await waitForEvent(correlationId);
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}
